/**
 * @author LB
 * @description 虚拟树组件
 */
import GlVirtualTree from './tree';

export default {
  install: function (Vue) {
    Vue.component('gl-virtual-tree', GlVirtualTree);
  },
};
